import { Component } from '@angular/core';

@Component({
  selector: 'app-member-successful',
  imports: [],
  templateUrl: './member-successful.component.html',
  styleUrl: './member-successful.component.css'
})
export class MemberSuccessfulComponent {
  closed()
  {
    window.location.href = 'https://line.me/R/ti/p/@cityparking';
  }
}
